import { useSendersInfoLoading } from './useSendersInfoLoading'
import { useRecipientsInfoLoading } from './useRecipientsInfoLoading'


export function useTransferLoading() {
  const sendersLoading = useSendersInfoLoading()
  const recipientsLoading = useRecipientsInfoLoading()
  return sendersLoading || recipientsLoading
}
